import { render, staticRenderFns } from "./SuccessorBlock.vue?vue&type=template&id=65395456"
import script from "./SuccessorBlock.vue?vue&type=script&lang=js"
export * from "./SuccessorBlock.vue?vue&type=script&lang=js"
import style0 from "./SuccessorBlock.vue?vue&type=style&index=0&id=65395456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports